import * as React from "react";
import { FunctionComponent, useState, useEffect } from 'react';
import { Link, NavLink } from "react-router-dom";
import { CSSTransition } from 'react-transition-group'; 
import { ClaimStart } from "./ClaimForms/ClaimStart";

export const ClaimSelection: FunctionComponent = () => {
    const[firstLoad, setFirstLoad] = useState<boolean>(true);
    const [isQuincy,setIsQuincy] = useState<boolean>(false);
    const [propertyPolicyList,setPropertyPolicyList] = useState<string[]>([]);
	const [autoPolicyList, setAutoPolicyList] = useState<string[]>([]);
	const [generalLiabilityPolicyList, setGeneralLiabilityPolicyList] = useState<string[]>([]);
    const [policyList, setPolictyList] = useState<string[]>([]);
    const [showPropertyClaimStart, setShowPropertyClaimStart] = useState<boolean>(false);
    const [showStart, setShowStart] = useState<boolean>(true);
	const [type, setType] = useState<string>("");
	const [width, setWidth] = useState<number>(window.innerWidth);

	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener('resize', handleWindowSizeChange);
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		}
	}, []);

	useEffect(() => {
        if(firstLoad)
        {
            localStorage.removeItem("autoclaim-bestcontact");
            localStorage.removeItem("autoclaim-airbags");
            localStorage.removeItem("autoclaim-isDriveable");
            localStorage.removeItem("autoclaim-areinjuries");
            localStorage.removeItem("autoclaim-arewitness");
            localStorage.removeItem("autoclaim-lossdate");
            localStorage.removeItem("autoclaim-inj1Open");
            localStorage.removeItem("autoclaim-inj2Open");
            localStorage.removeItem("autoclaim-wit1Open");
            localStorage.removeItem("autoclaim-wit2Open");
            let claimsDom = document.getElementById("claims-app");
            var isQuincy = claimsDom!.getAttribute("data-isquincy");
            let propertyPoList = claimsDom!.getAttribute("data-policylist") as string;
			let autoPolList = claimsDom!.getAttribute("data-autopolicylist") as string;
			let generalLiabilityPolList = claimsDom!.getAttribute("data-generalliabilitypolicylist") as string;
            setIsQuincy(isQuincy === "true" ? true : false);
            setPropertyPolicyList(propertyPoList.split(","));
			setAutoPolicyList(autoPolList.split(","));
			setGeneralLiabilityPolicyList(generalLiabilityPolList.split(","));
            setFirstLoad(false);
        }
    },[firstLoad])
   return <div>
       {getHtmlToShow()}
       </div>;

    function progressBack()
    {
        setShowPropertyClaimStart(false);
    }

    function setStartView(claimType)
    {
		if (claimType === "auto") {
			setPolictyList(autoPolicyList);
			setType("auto");
		}
		else if (claimType === "property") {
			setPolictyList(propertyPolicyList);
			setType("property");
		}
		else if (claimType === "general liability") {
			setPolictyList(generalLiabilityPolicyList);
			setType("generalliability");
		}
        setShowStart(false);
	}

    function getHtmlToShow()
    {
        return <div className="container-start">
            <CSSTransition in={showPropertyClaimStart} timeout={300}
            classNames="claim-transition"
            unmountOnExit
            onExited={() => setShowStart(true)}>
                <ClaimStart isQuincy={isQuincy} policyOptions={policyList} claimType={type} progressBack={progressBack}/>
            </CSSTransition>
            <CSSTransition in={showStart} timeout={300} classNames="claim-transition"
            unmountOnExit
            onExited={() => setShowPropertyClaimStart(true)}>
                <div>
                <div>
                    <h1>REPORT A CLAIM</h1>
				</div>
				{width <= 1008 ?
						<div className="claim-group">
							<h2 className="header">What type of claim would you like to report?</h2>
							<div className="claim-selection">
								<button className="btn btn-primary" type="button" onClick={() => { setStartView("auto"); }}>AUTO</button>
								<button className="btn btn-primary" type="button" onClick={() => { navigate("/auto-glass-claim.htm"); }}>AUTO GLASS</button>
								{isQuincy
									? <button className="btn btn-primary" type="button" onClick={() => { navigate("/roadside-assistance-claim.htm"); }}>ROADSIDE ASSISTANCE</button>
									: null
								}
							</div>
							<div className="claim-selection">
								<button className="btn btn-primary" type="button" onClick={() => { setStartView("property"); }}>PROPERTY</button>
							<button className="btn btn-primary" type="button" onClick={() => { setStartView("general liability"); }}>GENERAL LIABILITY</button>
							</div>
						</div>
						:
						<div className="claim-group">
							<h2 className="header">What type of claim would you like to report?</h2>
							<div className="claim-selection">
								<button className="btn btn-primary" type="button" onClick={() => { setStartView("auto"); }}>AUTO</button>
								<button className="btn btn-primary" type="button" onClick={() => { navigate("/auto-glass-claim.htm"); }}>AUTO GLASS</button>
								{isQuincy
									? <button className="btn btn-primary" type="button" onClick={() => { navigate("/roadside-assistance-claim.htm"); }}>ROADSIDE ASSISTANCE</button>
									: null
								}
								<button className="btn btn-primary" type="button" onClick={() => { setStartView("property"); }}>PROPERTY</button>
								<button className="btn btn-primary" type="button" onClick={() => { setStartView("general liability"); }}>GENERAL LIABILITY</button>
							</div>
						</div>
				}
                {isQuincy ? <div>
                    <p><strong>Applicable to New York: </strong>Any person who knowingly and with intent to defraud any insurance company or other person files an application for
                    insurance or statement of claim containing any materially false information, or conceals for the purpose of misleading information concerning any fact materially
                    thereto, commits a fraudulent insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the stated value
                    of the claim for each such violation.</p>
                    <p><strong>Applicable to Rhode Island: </strong>Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents
                    false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.</p>
                </div> : null}
                {!isQuincy ? <div>
                    <p><strong>Applicable to Maine: </strong>It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of
                    defrauding the company.  Penalties may include imprisonment, fines or denial of insurance benefits.</p>
                    <p><strong>Applicable to New Hampshire: </strong>Any person who, with a purpose to injure, defraud or deceive any insurance company, files a statement of claim 
                    containing any false, incomplete or misleading information is subject to prosecution and punishment for insurance fraud as provided in RSA 638:20.</p>
                </div> : null}
                </div>
            </CSSTransition>
        </div>;
    }

    function navigate(location:string)
    {
        window.location.href = location;
    }
}
